import { c as _c } from "react/compiler-runtime";
import WavePicture from '@/components/waves/WavePicture';
import type { MinimalWave } from '@/contexts/wave/hooks/useEnhancedWavesList';
interface WaveAvatarProps {
  readonly isActive: boolean;
  readonly isDropWave: boolean;
  readonly showNewDropsBadge: boolean;
  readonly wave: MinimalWave;
}
const DROP_ICON = <svg className="tw-size-2.5 tw-flex-shrink-0 tw-text-[#E8D48A]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    <path fill="currentColor" d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" />
  </svg>;
export const WaveAvatar = t0 => {
  const $ = _c(14);
  const {
    isActive,
    isDropWave,
    showNewDropsBadge,
    wave
  } = t0;
  const t1 = `tw-relative tw-size-8 tw-rounded-full tw-transition tw-duration-300 desktop-hover:group-hover:tw-brightness-110 ${isActive ? "tw-opacity-100 tw-ring-1 tw-ring-offset-2 tw-ring-offset-iron-950 tw-ring-white/30" : "tw-opacity-80 desktop-hover:group-hover:tw-opacity-100 tw-ring-1 tw-ring-white/20"}`;
  let t2;
  if ($[0] !== wave.contributors || $[1] !== wave.name || $[2] !== wave.picture) {
    t2 = <WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors} />;
    $[0] = wave.contributors;
    $[1] = wave.name;
    $[2] = wave.picture;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isDropWave) {
    t3 = isDropWave && <div className="tw-absolute tw-bottom-[-2px] tw-right-[-2px] tw-size-3.5 tw-flex tw-items-center tw-justify-center tw-bg-iron-950 tw-rounded-full tw-shadow-lg">{DROP_ICON}</div>;
    $[4] = isDropWave;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== showNewDropsBadge || $[7] !== wave.newDropsCount) {
    t4 = showNewDropsBadge && <div className="tw-absolute tw-top-[-4px] tw-right-[-4px] tw-bg-indigo-500 tw-text-white tw-rounded-full tw-h-4 tw-min-w-4 tw-flex tw-items-center tw-justify-center tw-text-[10px] tw-font-medium tw-px-1 tw-shadow-sm">{wave.newDropsCount.count}</div>;
    $[6] = showNewDropsBadge;
    $[7] = wave.newDropsCount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};